import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import ProjectTemplate from '@/components/ProjectTemplate'
import { actionTypes } from '@/store/actionTypes'
import _ from 'lodash'
import AuthService from '@/modules/authentication/services/auth.service'
Vue.use(Router)

let router = new Router({
    base: process.env.BASE_URL,
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'default',
            redirect: '/dashboard'
        },
        {
            path: '/home',
            name: 'home',
            redirect: '/home'
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/Dashboard/Dashboard'),
            meta: { requiresAuth: true }
        },
        {
            path: '/campaign/:campaignId',
            name: 'ProjectTemplate',
            component: ProjectTemplate,
            redirect: '/dashboard',
            meta: { requiresAuth: true },
            children: [
                {
                    path: 'satisfaction',
                    name: 'satisfaction',
                    component: () => import('@/views/CustomerSatisfaction')
                },
                {
                    path: 'agent/overview',
                    name: 'AgentOverview',
                    component: () => import('@/views/Agent/AgentOverview')
                },
                {
                    path: 'agent/details',
                    name: 'AgentDetails',
                    component: () => import('@/views/Agent/AgentDetails')
                },
                {
                    path: 'bot/overview',
                    name: 'BotOverview',
                    component: () => import('@/views/Bot/BotOverview')
                },
                {
                    path: 'bot/details',
                    name: 'BotDetails',
                    component: () => import('@/views/Bot/BotDetails')
                },
                {
                    path: 'settings',
                    name: 'Settings',
                    component: () => import('@/views/Settings')
                }
            ]
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    let guard = true
    // check authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.state.auth.token) {
            guard = false
            store.dispatch(actionTypes.auth.SIGN_IN)
        }
    }
    if (!guard) {
        return
    }
    // check user role
    if (to.matched.some(record => Array.isArray(record.meta.roles) && record.meta.roles.length > 0)) {
        let userRoles = null
        if (store.state.auth.profile) {
            userRoles = store.state.auth.roles
        } else {
            try {
                let profileRes = await AuthService.getProfile()
                userRoles = profileRes.data.roles
            } catch (e) {
                router.push('/')
            }
        }
        if (Array.isArray(userRoles)) {
            for (let record of to.matched) {
                let routeRoles = record.meta.roles
                if (Array.isArray(routeRoles) && routeRoles.length > 0) {
                    if (_.difference(userRoles, routeRoles).length === userRoles.length) {
                        guard = false
                        router.push('/')
                        break
                    }
                }
            }
        } else {
            guard = false
        }
    }
    // continue in case everything is satisfied
    if (guard) {
        next()
    } else {
        router.push('/')
    }
})

export default router
